import { MigrationInterface, QueryRunner } from 'typeorm';
import { setMigrationRole } from './migration-role';

export class AddUserVerifiedAt1700000001000 implements MigrationInterface {
  name = 'AddUserVerifiedAt1700000001000';

  public async up(queryRunner: QueryRunner): Promise<void> {
    await setMigrationRole(queryRunner);
    try {
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        ADD COLUMN "verifiedAt" TIMESTAMPTZ
      `);

      await queryRunner.query(`
        UPDATE "app"."users"
        SET
          "verifiedAt" = COALESCE("createdAt", now())
        WHERE "verifiedAt" IS NULL
      `);
    } finally {
      await queryRunner.query('RESET ROLE');
    }
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    await setMigrationRole(queryRunner);
    try {
      await queryRunner.query(`
        ALTER TABLE "app"."users"
        DROP COLUMN "verifiedAt"
      `);
    } finally {
      await queryRunner.query('RESET ROLE');
    }
  }
}
